import React from 'react';
import { Icon, Text } from '../../Atoms';
import successIcon from '../../assets/icons/successIcon.svg';
import failedIcon from '../../assets/icons/failed.svg';
import nextIcon from '../../assets/icons/next.svg';

import { addMonths, isAfter, startOfMonth, subMonths, isWithinInterval } from 'date-fns';

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};
export const getNext10 = () => {
  const today = new Date();
  const startOfCurrentMonth = startOfMonth(today);
  const current10 = new Date(
    startOfCurrentMonth.getFullYear(),
    startOfCurrentMonth.getMonth(),
    10
  );

  // If the current 10 is before the given date, move to the 10 of the next month
  if (isAfter(today, current10)) {
    return addMonths(current10, 1);
  }

  return current10;
};

export const getPrevious10 = () => {
  const today = new Date();

  const startOfCurrentMonth = startOfMonth(today);
  const current10 = new Date(
    startOfCurrentMonth.getFullYear(),
    startOfCurrentMonth.getMonth(),
    10
  );

  // If the current 10 is after the given date, move to the 10 of the previous month
  if (isAfter(current10, today)) {
    return subMonths(current10, 1);
  }

  return current10;
};

const EcheanceList = ({ contract }) => {
  const echeances = contract.schedule?.maturities;
  const [pastEchances, setPastEcheances] = React.useState([]);
  const [futurEcheances, setFuturEcheances] = React.useState([]);
  const [currentEcheances, setCurrentEcheances] = React.useState([]);
   const today = new Date();
  React.useEffect(() => {
    const next10 = getNext10();
    const previous10 = getPrevious10();

    setPastEcheances(
      echeances?.filter((echeance) => {
        return isAfter(today, new Date(echeance.periodStart));
      })
    );
    setFuturEcheances(
      echeances?.filter((echeance) => {
        return isAfter(new Date(echeance.periodStart), today);
      })
    );

     setCurrentEcheances(
     echeances?.filter((echeance) => {
      const StartEacheance = new Date(echeance.periodStart);
      const EndEacheance = new Date(echeance.periodEnd);
      return isWithinInterval(today, { start: StartEacheance, end: EndEacheance });
    })
     );
  }, [echeances]);

  return (
    <>
      {!!currentEcheances?.length && (
           currentEcheances?.map((echeance, index) => ( 
          <EcheanceItem
            status={echeance?.amount > 0 ? 'payed' : 'failed'}
            echeance={echeance}
            key={index}
          />
        ))
        )}

        {!!futurEcheances?.length && (
           futurEcheances?.slice(0, 3)?.map((echeance, index) => ( 
          <EcheanceItem
            status={echeance?.amount > 0 ? 'payed' : 'failed'}
            echeance={echeance}
            key={index}
          />
        ))
        )}
    </>
  );
};

const EcheanceItem = ({ status, echeance }) => {
  const icon =
    status === 'payed'
      ? successIcon
      : status === 'failed'
      ? failedIcon
      : nextIcon;
  return (
    <div className="contract-item-container">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 10
        }}
      >
        <div>
          <img src={icon} alt="Success Icon" />
        </div>

        <div>
          <Text
            className="contract-benef-name"
            text={
              status === 'next'
                ? 'Prochaine cotisation'
                : echeance.remittanceInformation
            }
          />
          <Text
            className="contract-benef-title"
            text={` Du ${formatDate(new Date(echeance.periodStart))} au
              ${formatDate(new Date(echeance.periodEnd))}`}
          />
        </div>
      </div>

      <div className="echeance-amount-container">
        <div>
          <Text className="contract-benef-title" text={`${echeance.amount}€`} />
        </div>

        <div className="remboursement-desktop-organism-sort-icon-container">
          <Icon icon={'SortTop'} size="20px" className="icon-next-step" />
        </div>
      </div>
    </div>
  );
};

export default EcheanceList;
